import { useDebugValue, useMemo } from 'react';
import { toIdString } from '../utils/string/string';

export const useComponentId = (id) => {
  const componentId = useMemo(() => toIdString(id), [id]);
  useDebugValue(componentId);
  return componentId;
};
